<template lang="pug">
modal#rename-file-modal(
  :noFooter='true'
  :title='$t("modal.renameArchive.title")'
  @closed='close'
  ref='modal'
)
  ValidationObserver(ref='form' v-slot='{ valid, passes, handleSubmit }')
    form.form(@submit.prevent='handleSubmit(renameFile)')
      .row
        .col-12
          .form-group
            label(for='file-name') {{ $t('modal.renameArchive.fileNameLabel') }}
            .col-12.d-flex
              .form-control-icon
                icon(name='file')
            ValidationProvider(
              name='name'
              rules='required'
              v-slot='{ errors }'
            )
              input#file-name.form-control(
                :aria-label='$t("modal.renameArchive.fileNamePlaceholder")'
                :class='{ "border border-danger": errors[0] }'
                :placeholder='$t("modal.renameArchive.fileNamePlaceholder")'
                aria-describedby='file-extension'
                autocomplete='off'
                type='text'
                v-model='form.editableArchiveName'
              )
              small.text.text-danger.d-flex(v-if='errors.length > 0')
                icon(name='xmark')
                span.text.ms-2 {{ errors[0] }}
      .text-end.mt-2
        button.btn.btn-secondary(@click='close' type='button') {{ $t('button.cancel') }}
        button.btn.btn-primary.ms-2(:disabled='!valid' type='submit')
          | {{ $t('button.save') }}
</template>

<script>
import Icon from '@/ui/atoms/Icon.vue';
import Modal from '@/ui/molecules/Modal.vue';
import StorageHttp from '@/services/StorageHttp';
import alert from '@/modules/account/common/alert';

export default {
  components: {
    Modal,
    Icon,
  },
  props: {
    file: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: {
        editableArchiveName: '',
        fileExtension: '',
      },
      errors: [],
    };
  },
  watch: {
    file(newValue) {
      [this.form.editableArchiveName, this.form.fileExtension] =
        newValue.name.split('.');
    },
  },
  methods: {
    renameFile() {
      this.$loading(true);
      StorageHttp.supressDefault = true;
      StorageHttp.renameItem(
        this.file.id,
        `${this.form.editableArchiveName}.${this.form.fileExtension}`
      )
        .then(() => {
          this.$emit('renamed');
          this.$refs.modal.close();
        })
        .catch((err) => {
          if (err.response.status === 422) {
            this.$refs.form.setErrors(err.response.data.errors);
          }

          if (err.response.status === 404) {
            this.$refs.modal.close();
            alert.fireAlert(this.$t('alert.archiveNotFoundError'), {
              classes: 'alert-danger',
              styles:
                'background-color: #f8d7da; border-color: #f5c6cb; color: #721c24;',
              icon: 'triangle-exclamation',
            });
          }
        })
        .finally(() => {
          this.$loading(false);
          StorageHttp.supressDefault = false;
        });
    },
    resetForm() {
      [this.form.editableArchiveName] = this.file.name.split('.');
      this.$refs.form.reset();
    },
    close() {
      this.resetForm();
      this.$refs.modal.close();
    },
  },
};
</script>

<style scoped lang="stylus">
#file-name
  padding: 0px 45px
</style>
